import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const EditPU = (props) => {
  const [value, setValue] = useState(props.client.ugoda);
  const [loading, setLoading] = useState(false);
  const [uploadFiles, setUploadFiles] = useState("");
  const [uploadFilesArray, setUploadFilesArray] = useState([]);
  const [uploadFilesNamesArray, setUploadFilesNamesArray] = useState([]);
  const [uploadFilesNamesArrayChanged, setUploadFilesNamesArrayChanged] =
    useState([]);
  const [inputs, setInputs] = useState({});
  const [fileType, setFileType] = useState("bank");
  const [content, setContent] = useState("");
  const [uOptions, setUOptions] = useState([]);

  const editClient = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      if (value === "TAK") {
        if (uploadFilesArray.length === 0) {
          var body = {
            id: props.client.id,
            ugoda: value,
            ugoda_note: content.replaceAll("'", ""),
            ugoda_link: "",
          };

          await fetch("https://apidevkppp.ftpeople.pl/addUClient", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.text())
            .then((data) => {
              props.logClientAction(
                "Edytowano informację o ugodzie",
                props.client.id
              );

              MySwal.fire({
                icon: "success",
                title: "Edytowano",
                text: "sprawę",
              }).then(async (result) => {
                props.close();
              });
            })
            .catch((error) => {});
        } else {
          var length = uploadFilesArray.length;
          var progr = 0;
          if (length > 0) {
            uploadFilesArray.map(async (file) => {
              let formData = new FormData();
              formData.append("file", file);
              formData.append("type", fileType);
              formData.append("clientId", props.client.id);
              formData.append("taskId", "");
              formData.append("user", props.user);

              await fetch("https://apidevkppp.ftpeople.pl/uploadFile", {
                method: "POST",
                body: formData,
              })
                .then((response) => {
                  return response.text();
                })
                .then(async (responseJson) => {
                  ++progr;
                  MySwal.fire({
                    icon: "success",
                    title: "Wysłano plik: " + progr + "/" + length,
                    text: "",
                  }).then(async (result) => {
                    if (progr === length) {
                      var body = {
                        id: props.client.id,
                        ugoda: value,
                        ugoda_note: content.replaceAll("'", ""),
                        ugoda_link: responseJson,
                      };

                      await fetch("https://apidevkppp.ftpeople.pl/addUClient", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body),
                      })
                        .then((response) => response.text())
                        .then((data) => {
                          props.logClientAction(
                            "Edytowano informację o ugodzie",
                            props.client.id
                          );

                          MySwal.fire({
                            icon: "success",
                            title: "Edytowano",
                            text: "sprawę",
                          }).then(async (result) => {
                            props.close();
                          });
                        })
                        .catch((error) => {});
                    }
                  });
                });
            });
          } else {
            var body = {
              id: props.client.id,
              ugoda: value,
              ugoda_note: content.replaceAll("'", ""),
              ugoda_link: responseJson,
            };

            await fetch("https://apidevkppp.ftpeople.pl/addUClient", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.text())
              .then((data) => {
                props.logClientAction(
                  "Edytowano informację o ugodzie",
                  props.client.id
                );

                MySwal.fire({
                  icon: "success",
                  title: "Edytowano",
                  text: "sprawę",
                }).then(async (result) => {
                  props.close();
                });
              })
              .catch((error) => {});
          }
        }
      } else {
        var body = {
          id: props.client.id,
          ugoda: value,
          ugoda_note: "",
          ugoda_link: "",
        };

        await fetch("https://apidevkppp.ftpeople.pl/addUClient", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            props.logClientAction(
              "Edytowano informację o ugodzie",
              props.client.id
            );

            MySwal.fire({
              icon: "success",
              title: "Edytowano",
              text: "sprawę",
            }).then(async (result) => {
              props.close();
            });
          })
          .catch((error) => {});
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const changeFiles = (e) => {
    setUploadFiles([]);
    setUploadFilesArray([]);
    setUploadFilesNamesArray([]);

    var check = false;

    Array.from(e.target.files).map((file) => {
      if (file.size > 41943040) {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "plik przekracza 40MB",
        });
        check = true;
      }
    });

    if (check) {
      return;
    }

    setUploadFiles(e.target.files);
    setUploadFilesArray(Array.from(e.target.files));
    var arr = [];
    Array.from(e.target.files).map((el, index) => {
      arr.push({ id: index, name: el.name });
    });
    setUploadFilesNamesArray(arr);
  };

  const changeFileName = (e) => {
    if (inputs[e.target.value] === "" || inputs[e.target.value] === undefined) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    } else {
      var name = inputs[e.target.value];
      var newFile = new File(
        [uploadFilesArray[e.target.value]],
        name + "." + uploadFilesArray[e.target.value].name.split(".")[1],
        {
          type: uploadFilesArray[e.target.value].type,
        }
      );

      var arr = uploadFilesArray.filter(
        (el, index) => index !== +e.target.value
      );
      arr.push(newFile);

      setUploadFilesArray(arr);
      inputs[e.target.value] = "";
    }
  };

  const deleteTempFile = (e) => {
    var arr = uploadFilesArray.filter((el, index) => index !== +e.target.value);

    setUploadFilesArray(arr);
  };

  const sendFiles = async (e) => {
    props.logClientAction("Edytowano informację o ugodzie", props.client.id);

    MySwal.fire({
      icon: "success",
      title: "Edytowano",
      text: "sprawę",
    }).then(async (result) => {
      props.close();
    });
  };

  const validatePayment = (e) => {
    if (value.length > 0) {
      if (value === "TAK") {
        if (content.length > 0) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  };

  const handleContentChange = (e) => {
    setContent(e.target.value);
  };

  const createYesNoOptions = (e) => {
    var statusOptions = [];
    statusOptions.push({ label: "TAK", value: "TAK" });
    statusOptions.push({ label: "NIE", value: "NIE" });
    statusOptions.push({ label: "Brak danych", value: "Brak danych" });

    return statusOptions;
  };

  useEffect(() => {
    setUOptions(createYesNoOptions());
  }, []);

  return (
    <div className="mainContainerAddClient">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="sepAddC">Informacje o sprawie</div>

          <div className="inputBox">
            <div className="inputCol_3">
              <label>
                Propozycja ugodowa <span className="requiredStar">*</span>
              </label>
              <Select
                noOptionsMessage={() => "Brak danych"}
                placeholder={"Wybierz..."}
                isClearable={false}
                options={uOptions}
                onChange={(e) => setValue(e.value)}
              />
            </div>
          </div>
          {value === "TAK" ? (
            <>
              <input
                style={{ marginTop: "5vh" }}
                multiple={false}
                type="file"
                onChange={changeFiles}
              />
              {uploadFilesArray.length > 0 ? (
                <>
                  <table
                    style={{ width: "80%" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Plik</th>
                      <th></th>
                    </tr>
                    {uploadFilesArray.length > 0
                      ? uploadFilesArray.map((el, index) => (
                          <>
                            <tr>
                              <td
                                style={{
                                  width: "50%",
                                  padding: "5px 20px",
                                  height: "3vh",
                                }}
                              >
                                <div style={{ display: "flex", gap: "10px" }}>
                                  <input
                                    id={"fn" + index}
                                    name={"fn" + index}
                                    style={{ height: "2vh", marginTop: "0" }}
                                    type="text"
                                    value={inputs[index]}
                                    onChange={(e) =>
                                      setInputs((prev) => {
                                        return {
                                          ...prev,
                                          [index]: e.target.value,
                                        };
                                      })
                                    }
                                  />
                                  <button
                                    className="refreshButton"
                                    value={index}
                                    onClick={changeFileName}
                                  >
                                    zmień
                                  </button>
                                </div>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  width: "40%",
                                  padding: "5px 20px",
                                  height: "3vh",
                                }}
                              >
                                {el.name}
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  width: "10%",
                                  padding: "5px 20px",
                                  height: "3vh",
                                }}
                              >
                                <button
                                  className="refreshButton"
                                  value={index}
                                  onClick={deleteTempFile}
                                >
                                  usuń
                                </button>
                              </td>
                            </tr>
                          </>
                        ))
                      : ""}
                  </table>
                </>
              ) : (
                ""
              )}
              <div
                style={{ marginTop: "5vh", marginBottom: "5vh" }}
                className="inputBox"
              >
                <div className="inputCol_2">
                  <label>Treść ugody</label>
                  <textarea
                    spellCheck="false"
                    className="textAreaNote"
                    type="text"
                    id="url"
                    name="url"
                    value={content}
                    onChange={handleContentChange}
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editClient}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditPU;
